import type { ViewComponent } from "@frui.ts/views";
import type ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import ChargeDetailSection from "../chargeDetailSection";
import { Col, Form, Row } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import React from "react";
import { formatDateTime } from "utils/localizations";
import SourceType from "entities/sourceType";
import { chargeOrderStatusToVariant } from "entities/chargeOrderStatus";
import EshopOrderSection from "./eshopOrderSection";
import SalesPointOrderSection from "./salesPointOrderSection";
import KioskOrderSection from "./kioskOrderSection";
import { emptyValue } from "utils/emptyValue";

export const emptyValueFormatter = (value: any) => (!value ? emptyValue : value);

const ChargeDetailOrderSection: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => {
  const order = vm.item.chargeOrderDetail;
  let sourceOrderDetail;

  if (order.sourceType === SourceType.Eshop) {
    sourceOrderDetail = <EshopOrderSection vm={vm} />;
  } else if (order.sourceType === SourceType.Kiosk && order.kioskOrderDetail) {
    sourceOrderDetail = <KioskOrderSection vm={vm} />;
  } else if (order.sourceType === SourceType.Salespoint && order.distributorOrderDetail) {
    sourceOrderDetail = <SalesPointOrderSection vm={vm} />;
  }

  return (
    <ChargeDetailSection title={vm.translate("orderDetail")}>
      <Row>
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "status")}</Form.Label>
          <FakeInput
            target={order}
            property="status"
            valueFormatter={value => {
              const formattedValue = vm.translateChargeOrderStatus(value);
              return <strong className={`text-${chargeOrderStatusToVariant(value)}`}>{formattedValue}</strong>;
            }}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "isBulkChargeOrder")}</Form.Label>
          <FakeInput
            target={order}
            property="isBulkChargeOrder"
            valueFormatter={value => (value ? vm.translate("orderType.bulk") : vm.translate("orderType.single"))}
          />
        </Form.Group>
        <Form.Group as={Col} md={12} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "variableSymbol")}</Form.Label>
          <FakeInput target={order} property="variableSymbol" />
        </Form.Group>
        {sourceOrderDetail}
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "createdAt")}</Form.Label>
          <FakeInput target={order} property="createdAt" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "confirmedAt")}</Form.Label>
          <FakeInput
            target={order}
            property="confirmedAt"
            valueFormatter={value => (value ? formatDateTime(value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "id")}</Form.Label>
          <FakeInput target={order} property="id" />
        </Form.Group>
      </Row>
    </ChargeDetailSection>
  );
});

export default ChargeDetailOrderSection;
